<template>

    <div>
        <WaitingPrice
            :entity-type="BUSINESS_TYPE.RESTAURANT"
            :entity-id="+$route.params.id"
        >
            <template v-slot:tabs>
                <RestaurantsTabLinks />
            </template>
        </WaitingPrice>
    </div>

</template>

<script>
    import RestaurantsTabLinks from '@/components/RestaurantsTabLinks';
    import WaitingPrice from '@/components/waiting-price/WaitingPrice';
    import { BUSINESS_TYPE } from '@/utils/order';

    export default {

        name: 'EntityWaitingPrice',

        components: {
            RestaurantsTabLinks,
            WaitingPrice
        },
  
        data () {
            return {
                BUSINESS_TYPE,
                entity: {}
            }
        },
    
        computed: {},

        async mounted() {
        },

        methods: {}
    }
</script>
